import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import './SipPriDiagnostics.css';
import CustomModal from '../../../../CustomModal';
import { sipPriDiagnosticsPort } from '../../../../../actions/EpikBoxes';
import { useDispatch } from 'react-redux';
import Spinner from '../../../../../components/Spinner/Spinner';
import { dataCenterShellUrls } from '../../../BoxOverview';
import socketIOClient from 'socket.io-client';
import { useSelector } from 'react-redux';
import SpinnerCircles from '../../../../Spinner/SpinerCircles';

// const item = "<p style=\"background-color: #000000;color:white\">\u001b<span style=\"color:yellow\">2023-12-01 19:47:31.814409 [DEBUG] sofia_reg.c:2526 Changing expire time to 300 by request of proxy sip:10.254.0.157<br />\u001b<span style=\"color:white\">freeswitch@freeswitch> </p>"


const active_call_monitoring = 'active_call_monitoring'
const termianlCommands = [
  'voice_summary',
  active_call_monitoring,
  'voice_verbose',
  'pri_isdn',
  "test_fun"
]
function SipPriDiagnostics({ title, isOpen, setIsOpen, data, box }) {
  const [selectedValue, setSeletectedValue] = useState('');
  const [isloading, setIsloading] = useState(false);
  // const [ExecuteBtn, setExecuteBtn] = useState(false);
  const [isExecuteModelOpen, setIsExecuteModelOpen] = useState(false);
  const [channelId, setChannelId] = useState('');
  const [diagnosticResponse, setDiagnosticResponse] = useState('');
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const user = useSelector(state => state.AppState.user)
  const serialNumberDash = `${boxDetails.serialNumber}-${user._id}-pri`;
  const [stateSocket, setStateSocket] = useState(null);
  const [showPRIWarning, setShowPRIWarning] = useState(false)
  const [previousCommand, setPreviousCommand] = useState('')


  const getSocketRes = (socket) => {
    console.log('socket response getting try')
    socket && socket.on(`rce-${serialNumberDash}-command`, data => {
      console.log('socket pri data is ', data);
      ((selectedValue === active_call_monitoring || selectedValue === 'voice_summary') && selectedValue === previousCommand) ?
        setDiagnosticResponse(diagnosticResponse + data?.output) :
        setDiagnosticResponse(data?.output);

      isOpen && setIsExecuteModelOpen(true);
      setPreviousCommand(selectedValue)
    });
  }
  const handleApi = async () => {

    const isPRITermianlCommand = termianlCommands.indexOf(selectedValue);
    console.log({ selectedValue, isPRITermianlCommand })
    let res = ''
    if (isPRITermianlCommand >= 0) {
      setShowPRIWarning(true);

      const command = {
        description: " ",
        name: selectedValue?.replace(' ', ''),
      }
      console.log('socket cmnd ', command)
      //socket connection
      const baseUrl = dataCenterShellUrls[boxDetails.datacenter];
      let socket = stateSocket;
      if (!socket) {
        socket = socketIOClient.connect(baseUrl, { query: { token } });
        console.log('socket instance ', socket)
        setStateSocket(socket);
        socket.on('connect', async () => {
          console.log('socket connect ')

          socket.emit('RCE', {
            serialNumber: serialNumberDash,
            command: 'getList',
            ip: boxDetails.vpnAddress,
          });
          setStateSocket(socket);
          await new Promise(resolve => {
            socket.on(`rce-${serialNumberDash}-list`, data => {
              socket.emit('RCE', {
                serialNumber: serialNumberDash,
                // command: "active_call_monitoring",
                command: command,
                ip: boxDetails.vpnAddress,
              });

              getSocketRes(socket)
              resolve();
            });
          });
        });
      }
      else {
        console.log('sockect exits')
        socket && socket.emit('RCE', {
          serialNumber: serialNumberDash,
          command: command,
          ip: boxDetails.vpnAddress,
        });
        getSocketRes(socket)
      }
      setTimeout(() => {
        setShowPRIWarning(false)
      }, 8000)
    } else {
      const object = {
        id: box?._id,
        channelId,
        isPri: title === 'PRI',
        type: selectedValue?.replace(' ', ''),
      };
      setIsloading(true);
      res = await dispatch(sipPriDiagnosticsPort(token, object));


      if (res) {
        setDiagnosticResponse(res);
        setIsExecuteModelOpen(true);
      }
      setIsloading(false);
    }

  };
  useEffect(() => {
    if (data?.length) {
      setSeletectedValue(data?.[0]?.value);
    }
  }, [data]);
  useEffect(() => {
    if (selectedValue === 'dump') {
      setChannelId(1);
    } else {
      setChannelId('');
    }
  }, [selectedValue]);

  return (
    <div>
      <Modal id="portConfig" isOpen={isOpen} className="sipPri-diagnostics">
        <ModalHeader>{title} Diagnostic </ModalHeader>
        <ModalBody>
          <FormGroup row>
            {showPRIWarning && <p className='m-0 text-center' style={{ fontSize: 12 }}>Warning: This command can take long time in execution</p>}
            <Label for="name" sm={4}>
              {title}: 
            </Label>

            <Col sm={12}>
              <Row className="d-flex justify-content-between">
                <Col
                  sm={selectedValue === 'dump' ? 9 : 7}
                  className="d-flex justify-content-between"
                >
                  <Input
                    onChange={e => {
                      setSeletectedValue(e.currentTarget.value);
                    }}
                    placeholder="Please specify"
                    required
                    value={selectedValue}
                    type="select"
                    className="mr-3"
                    style={{ width: '100%' }}
                  >
                    {data?.map(item => <option value={item.value}>{item.label}</option>)}
                  </Input>
                  {selectedValue === 'dump' && (
                    <Input
                      onChange={e => setChannelId(e.currentTarget.value)}
                      placeholder="Please specify"
                      required
                      value={channelId}
                      type="select"
                      name="PRI"
                      style={{ width: '60%' }}
                      className=" mr-4"
                    >
                      {[...Array(24).keys()].map((item, index) => (
                        <option key={item + 1} value={item + 1}>
                          {item + 1}
                        </option>
                      ))}
                    </Input>
                  )}
                </Col>
                <Col sm={3}>
                  {selectedValue && (
                    <Button onClick={handleApi} color="primary" className="ml-4" disable={isloading}>
                      {isloading ? <SpinnerCircles /> : 'Execute'}
                    </Button>
                  )}
                </Col>
              </Row>
            </Col>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => {
            stateSocket && stateSocket.emit('RCE', {
              serialNumber: serialNumberDash,
              ip: boxDetails.vpnAddress,
              cleanup: true,
            });
            setIsOpen(false)
            setDiagnosticResponse('')
            setStateSocket(null)
          }}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      {isExecuteModelOpen && <CustomModal
        isOpen={isExecuteModelOpen}
        // isOpen={true}
        header={selectedValue?.toUpperCase()}
        onCancel={() => setIsExecuteModelOpen(false)}
        close="close"
        submitDisplay
        medium
      >
        {(selectedValue === active_call_monitoring || selectedValue === 'voice_summary' || selectedValue === 'test_fun') ? <p dangerouslySetInnerHTML={{ __html: diagnosticResponse.split('\\n').join('<br />') }}></p> :
          <pre
          style={{
            padding: '10px',
            backgroundColor: `${selectedValue === 'sofia Status' && 'black'}`,
            color: `${selectedValue === 'sofia Status' && 'white'}`,
          }}
        >
          {diagnosticResponse}
          </pre>
        }
      </CustomModal>}
    </div>
  );
}

export default SipPriDiagnostics;


